<!-- eslint-disable -->
<template lang="pug">
    .settings(v-if='settings')
        | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}:
        | {{ settings.combining ? $i18n.t('common')[settings.difficult] + ' (' + $i18n.t('trainer.trainer_gameFormSettingValue_combination') + ')' : $i18n.t('common')[settings.difficult] }}
        br
        template(v-if="parametersFrom === 'homework'")
            template(v-if='settings.mode')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}: {{ getModeName(settings.mode) }}
                br
            template(v-if='settings.amountOfExamples')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}: {{ settings.amountOfExamples }}
                br
            template(v-else-if='settings.timeLimit')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}:
                | {{ settings.timeLimit }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_minutes') }}
                br
            template(v-if='settings.amountOfActions')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfActions') }}: {{ settings.amountOfActions }}
                br
            |  {{ $i18n.t('trainer.trainer_gameFormSetting_numOfUnknowns') }}: {{ settings.amountOfUnknowns }}
            br
            template(v-if='settings.negativeAnswers')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_negativeAnswers') }}:
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                br
            template(v-if='settings.fractions')
                span
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}:
                    | {{ fractionalPart }}
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_afterPoint') }}
                br
        slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            parametersFrom: {
                type: String,
                default: 'homework'
            },
            userId: Number
        },
        computed: {
            amountOfActions () {
                return this.settings.complication + ' '
                    + this.$i18n.tc('trainer.trainer_gamePreview_actionDeclination', this.settings.complication);
            },
            fractionalPart() {
                return this.settings.fractionalPart + ' '
                    + this.$i18n.tc('trainer.trainer_gamePreview_numDeclination', this.settings.fractionalPart);
            }
        }
    }
</script>
